import { ReactNode } from 'react'

import {
  StyledListItem,
  StyledList,
  StyledH3,
  ZenkakuSpace,
} from '../TextStyle'

export const usingTerms: { children: ReactNode; id: string }[] = [
  {
    children: (
      <>
        <StyledH3>第1条（著作権について）</StyledH3>
        <p>
          本ウェブサイト上の文書・画像等すべての情報の著作権は、特別の断りがない限り、トライアルグループに帰属します。
        </p>
      </>
    ),
    id: 'copyright',
  },
  {
    children: (
      <>
        <StyledH3>第2条（文章及びその内容）</StyledH3>
        <p>
          トライアルグループは、本ウェブサイト上への情報掲載にあたって細心の注意を払っておりますが、その内容に誤りや欠陥があった場合にも、いかなる保証もするものではありません。本ウェブサイトをご利用いただいたことにより生じた損害につきましても、トライアルグループは一切責任を負いかねます。
          <br />
          また、本ウェブサイト上の情報は、予告なしに変更または廃止されることがありますので、あらかじめご了承ください。
        </p>
      </>
    ),
    id: 'article',
  },
  {
    children: (
      <>
        <StyledH3>第3条（禁止事項）</StyledH3>
        <p>
          利用者は、本ウェブサイトのご利用にあたり、本利用条件の規定により禁止する行為のほか、以下の行為を行ってはならないものとします。
        </p>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            トライアルグループまたは第三者の権利、利益またはプライバシーを侵害し、または侵害するおそれのある行為。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループまたは第三者に迷惑をかけ、または損害を与える行為、またはそれらのおそれのある行為。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループまたは第三者の名誉もしくは信用を毀損する行為。
          </StyledListItem>
          <StyledListItem listType="article">
            公序良俗に反する行為、法令・条例に違反する行為、またはそれらのおそれのある行為。
          </StyledListItem>
          <StyledListItem listType="article">
            犯罪行為もしくは犯罪行為に結びつく行為、またはそのおそれのある行為。
          </StyledListItem>
          <StyledListItem listType="article">
            本ウェブサイトを利用した営業行為、営利目的行為またはその準備を目的とした行為。
          </StyledListItem>
          <StyledListItem listType="article">
            ウェブサイトの運営を妨げ、またはトライアルグループのサービス提供に支障をきたすおそれのある行為。
          </StyledListItem>
          <StyledListItem listType="article">
            コンピュータウィルス等有害なプログラムを使用もしくは提供する行為、またはそのおそれのある行為。
          </StyledListItem>
          <StyledListItem listType="article">
            その他、トライアルグループが不適切と判断する行為。
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'restriction',
  },
  {
    children: (
      <>
        <StyledH3>第4条（サイトの中断・停止）</StyledH3>
        <p>
          トライアルグループは、システム保守（定期・不定期を問いません。）、天災地変等の不可抗力、やむを得ない事情、またはトライアルグループ独自の判断により、本ウェブサイトを中断（一時的な中断を含みます。）または停止することがあります。利用者が本ウェブサイトを利用することができなかったことにより生じた不利益や損害等について、トライアルグループは一切の責任を負わないものとします。
        </p>
      </>
    ),
    id: 'stoppage',
  },
  {
    children: (
      <>
        <StyledH3>第5条（商品・サービスの対象国、地域）</StyledH3>
        <p>
          本ウェブサイトに掲載されている情報は、日本国内向けに提供する商品／サービスの情報で、日本に在住している方のみが購入／入手可能です。なお、個々のコンテンツにおいて、個別に提供国／地域が示されている場合、またはそれを示すコンテンツにリンクしている場合には、当該情報が優先されます。
        </p>
      </>
    ),
    id: 'region',
  },
  {
    children: (
      <>
        <StyledH3>第6条（本ウェブサイトへのリンク）</StyledH3>
        <p>
          本ウェブサイトへのリンクは、トップページへのリンクに限り、フリーです。
          <br />
          但し、以下の注意事項に従っていただけますよう、お願いいたします。
        </p>
        <ul>
          <li>
            <span style={{ color: '#002D65' }}>リンクに関する注意事項</span>
          </li>
          <li>
            <StyledList marginLeft="0.5" paddingLeft="0.5">
              <StyledListItem listType="article">
                「トライアルグループ」と明記してください。
              </StyledListItem>
              <StyledListItem listType="article">
                ロゴマークの使用はご遠慮ください。
              </StyledListItem>
              <StyledListItem listType="article">
                独立したウィンドウでの表示とし、トライアルグループのウェブサイトであることを明確にしてください。
              </StyledListItem>
              <StyledListItem listType="article">
                次のようなウェブサイトからのリンクは、固くお断りいたします。
                <StyledList marginLeft="1" paddingLeft="0.5">
                  <StyledListItem listType="disc">
                    トライアルグループ及び第三者の権利を侵害する内容のウェブサイト
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    トライアルグループ及び第三者に誤解・誤認・迷惑を与える内容のウェブサイト
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    公序良俗に反する内容のウェブサイト
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    違法または違法な可能性のある表現及び活動に関する内容のウェブサイト
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    その他トライアルグループがリンク元として不適切と判断するウェブサイト
                  </StyledListItem>
                </StyledList>
              </StyledListItem>
            </StyledList>
          </li>
          <li>
            <p>
              以上のリンク方法、注意事項に従っていただけない場合は、トライアルグループからリンクの削除を申し入れる場合がありますので、ご了承ください。
              <br />
              また、申し入れ後は直ちに削除してください。
            </p>
          </li>
        </ul>
      </>
    ),
    id: 'links',
  },
  {
    children: (
      <>
        <p>
          制定日
          <ZenkakuSpace />
          2022年12月26日
        </p>
      </>
    ),
    id: 'enactment',
  },
]

export const usingTermsLinks: {
  name: string
  anchor: string
}[][] = [
  [
    {
      name: '（著作権について）',
      anchor: 'copyright',
    },
    {
      name: '（文章及びその内容）',
      anchor: 'article',
    },
    {
      name: '（禁止事項）',
      anchor: 'restriction',
    },
  ],
  [
    {
      name: '（サイトの中断・停止）',
      anchor: 'stoppage',
    },
    {
      name: '（商品・サービスの対象国、地域）',
      anchor: 'region',
    },
    {
      name: '（本ウェブサイトへのリンク）',
      anchor: 'links',
    },
  ],
]
